<template>
    <transition name="slide">
        <router-view>

        </router-view>
    </transition>
</template>

<script>
    export default {
        name: "BaseFAQ",
    }
</script>

<style scoped>

</style>